"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../../ScreenReaderText"));

var _useDateFormatter = _interopRequireDefault(require("../../hooks/useDateFormatter"));

var _useLocalizer = _interopRequireDefault(require("../../hooks/useLocalizer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AbsoluteTime = function AbsoluteTime(_ref) {
  var value = _ref.value;
  var localize = (0, _useLocalizer.default)();
  var formatDate = (0, _useDateFormatter.default)();
  var absoluteTime = formatDate(value);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: localize('ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT', absoluteTime)
  }), _react.default.createElement("span", {
    "aria-hidden": true
  }, absoluteTime));
};

AbsoluteTime.propTypes = {
  value: _propTypes.default.string.isRequired
};
var _default = AbsoluteTime;
exports.default = _default;